/* ============================================================================
   LAH — RECUPERAR O CARRINHO DENTRO DO SITE
   Tema: Testes de implementacao (0.8)

   Quando o visitante volta ao site com itens no carrinho de uma visita
   anterior, um aviso sobe de baixo lembrando o que ficou para tras.

   ============================================================================
   POR QUE ESTE E O ABANDONO MAIS CARO
   ============================================================================
   Nos ultimos 14 dias: 2.175 view_cart contra 683 begin_checkout. Mil e
   quinhentas pessoas abriram o carrinho e nao seguiram — depois de montar o
   oculos inteiro, escolher lente e tratamento.

   E-mail de carrinho abandonado chega horas depois, quando a intencao ja
   esfriou. Aqui a pessoa esta no site AGORA, de novo.

   ============================================================================
   DOIS SEGUNDOS — e por que nao seis
   ============================================================================
   A contagem REINICIA a cada pagina: ela mede tempo na pagina, nao tempo no
   site. Com seis segundos, quem navega rapido — catalogo, produto, outro
   produto — nunca chegava ao fim da contagem em lugar nenhum, e o aviso
   simplesmente nao existia para quem mais navega.

   Dois segundos e o suficiente para a pagina pintar e a pessoa se situar, sem
   depender de ela parar. O preco e aparecer mais cedo do que o ideal para quem
   fica; o ganho e existir para quem passa.

   ============================================================================
   "VOLTOU" — COMO SABEMOS
   ============================================================================
   Pelo sessionStorage: se nao ha marca desta sessao e o carrinho tem itens,
   eles vieram de antes. Assim quem acabou de adicionar nao leva um aviso do
   que fez trinta segundos atras.

   ============================================================================
   UM AVISO POR DIA, COMPARTILHADO
   ============================================================================
   Este aviso e o de configuracao guardada dividem a MESMA chave de controle
   diario. Este roda um segundo antes de proposito: carrinho com itens esta
   mais perto da compra do que uma configuracao pela metade.

   Nunca aparece no carrinho nem no checkout: la a pessoa ja esta fazendo o que
   o aviso pediria.
   ============================================================================ */

(function () {
    'use strict';

    /* A mesma chave usada por lah-retomar-toast.js — ver nota acima. */
    var CHAVE_DIA = 'lah_retomar_toast_dia';
    var CHAVE_SESSAO = 'lah_carrinho_sessao';
    var ESPERA_MS = 2000;

    var caminho = window.location.pathname;
    if (caminho.indexOf('/cart') === 0) return;
    if (caminho.indexOf('/checkout') === 0) return;

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function hoje() {
        var d = new Date();
        var m = d.getMonth() + 1;
        var dia = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (dia < 10 ? '0' + dia : dia);
    }

    function jaViuHoje() {
        try {
            return window.localStorage.getItem(CHAVE_DIA) === hoje();
        } catch (e) {
            return true; /* sem storage, nao insistimos */
        }
    }

    function marcarVisto() {
        try {
            window.localStorage.setItem(CHAVE_DIA, hoje());
        } catch (e) { /* ignora */ }
    }

    /* Marca esta sessao. Quem adicionou agora nao e "quem voltou". */
    function sessaoNova() {
        try {
            if (window.sessionStorage.getItem(CHAVE_SESSAO)) return false;
            window.sessionStorage.setItem(CHAVE_SESSAO, '1');
            return true;
        } catch (e) {
            return false;
        }
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    /* A descricao conta ARMACOES, nao linhas: o carrinho de um oculos tem
       armacao, lente, tratamento e kit — dizer "4 itens" para um par de oculos
       confundiria mais do que ajudaria. */
    function descrever(cart) {
        var armacoes = 0;
        var primeira = null;

        cart.items.forEach(function (item) {
            var props = item.properties || {};
            if (!props.custom) return;

            armacoes += item.quantity;
            if (!primeira) primeira = item;
        });

        if (!armacoes) return null;

        return {
            texto: armacoes === 1
                ? (primeira.product_title || 'Óculos') + ' está no seu carrinho'
                : armacoes + ' óculos estão no seu carrinho',
            imagem: primeira.image || '',
            total: cart.total_price
        };
    }

    function montar(info) {
        var caixa = document.createElement('div');
        caixa.className = 'lah-toast';
        caixa.setAttribute('role', 'status');

        var html = '';

        if (info.imagem) {
            html += '<img class="lah-toast__img" src="' + info.imagem +
                '" alt="" loading="lazy" width="46" height="46">';
        }

        html += '<span class="lah-toast__corpo">' +
            '<span class="lah-toast__titulo">' + info.texto + '</span>' +
            '<span class="lah-toast__detalhe">Total ' + moeda(info.total) + '</span>' +
            '</span>' +
            '<a class="lah-toast__btn" href="/cart" data-cart-continuar>Finalizar</a>' +
            '<button type="button" class="lah-toast__close" aria-label="Fechar" data-cart-fechar>&times;</button>';

        caixa.innerHTML = html;
        document.body.appendChild(caixa);

        /* Dois quadros antes de abrir: sem isso o navegador pinta o elemento ja
           na posicao final e a animacao de subida nao acontece. */
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                caixa.classList.add('is-open');
            });
        });

        caixa.addEventListener('click', function (event) {
            if (event.target.closest('[data-cart-continuar]')) {
                track('cart_recuperado', { valor: info.total / 100 });
                return; /* o link segue normalmente */
            }

            if (event.target.closest('[data-cart-fechar]')) {
                track('cart_recuperar_dispensado', {});
                caixa.classList.remove('is-open');
                setTimeout(function () { caixa.remove(); }, 350);
            }
        });

        /* Marcamos ao APARECER, nao ao fechar: quem ignora e navega veria de
           novo na pagina seguinte. */
        marcarVisto();
        track('cart_recuperar_exibido', { valor: info.total / 100 });
    }

    if (jaViuHoje()) return;

    /* A marca de sessao e gravada agora, no carregamento, e nao depois da
       espera: se a pessoa navegar antes dos 2 segundos, a proxima pagina ja
       sabe que a sessao comecou aqui. */
    var eRetorno = sessaoNova();
    if (!eRetorno) return;

    setTimeout(function () {
        /* Conferimos de novo: o outro aviso pode ter ocupado o lugar do dia. */
        if (jaViuHoje()) return;

        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                if (!cart || !cart.items || !cart.items.length) return;

                var info = descrever(cart);
                if (info) montar(info);
            })
            .catch(function () {
                /* Sem carrinho legivel, nao ha aviso — e nada quebra. */
            });
    }, ESPERA_MS);
})();
